<ng-template #modalDeleteMultiple let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="modalDeleteMultipleForm()"
    (dismiss)="d()"
    cancelButtonEnable="true"
    title="{{ 'common_attention' | translate }}"
    text="{{ 'contact_delete_confirm' | translate }}"
  ></wsb-modal>
</ng-template>
<ng-template #modalAddRemoveCreateGroup let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="modalAddRemoveCreateGroupForm()"
    cancelButtonEnable="true"
    (dismiss)="d()"
    title="{{
      (groupOperation === 'create' ? 'contacts_create_group' : groupOperation === 'add' ? 'contacts_add_group' : 'contacts_remove_group')
        | translate
    }}"
  >
    <div body>
      <ng-container *ngIf="groupOperation === 'create'">
        <form [formGroup]="createGroupForm">
          <label for="group_name" translate>contacts_group_name</label>
          <input type="text" id="group_name" formControlName="name" name="group_name" class="form-control  form-control--short" />
          <wsb-validation-error-msg [fc]="createGroupForm.get('name')"></wsb-validation-error-msg>
          <label for="group_description" translate>common_description</label>
          <textarea
            id="group_description"
            formControlName="description"
            name="group_description"
            class="form-control  form-control--short"
          ></textarea>
          <wsb-validation-error-msg [fc]="createGroupForm.get('description')"></wsb-validation-error-msg>
        </form>
      </ng-container>
      <ng-container *ngIf="groupOperation === 'add' || groupOperation === 'remove'">
        <wsb-atlas-grid
          class="atlas-grid-simplest"
          class="mt-2"
          [loading]="tableGroupLoading"
          [columnDefs]="tableGroupColumnDefs"
          [options]="tableGroupGridOptions"
          [@gridIsLoaded]="gridAnimationStateGroup"
          [components]="frameworkGroupComponents"
        >
        </wsb-atlas-grid>
      </ng-container>
    </div>
  </wsb-modal>
</ng-template>
<ng-template #modalExport let-c="close" let-d="dismiss">
  <wsb-modal
    primaryButtonText="{{ 'common_export' | translate }}"
    (primary)="modalExportForm()"
    cancelButtonEnable="true"
    (dismiss)="d()"
    title="{{ 'contacts_export_modal' | translate }}"
  >
    <div body>
      <form [formGroup]="exportForm">
        <p translate>contacts_export_text</p>

        <label class="radio-custom">
          <input type="radio" name="format" formControlName="format" value="XLS" />
          <span class="radio-custom__radio"></span>
          <span class="radio-custom__label" translate>export_filetype_xls</span>
        </label>
        <label class="radio-custom">
          <input type="radio" name="format" formControlName="format" value="XLSX" />
          <span class="radio-custom__radio"></span>
          <span class="radio-custom__label" translate>export_filetype_xlsx</span>
        </label>
        <label class="radio-custom">
          <input type="radio" name="format" formControlName="format" value="CSV" />
          <span class="radio-custom__radio"></span>
          <span class="radio-custom__label" translate>export_filetype_csv</span>
        </label>
        <wsb-validation-error-msg [fc]="exportForm.get('format')"></wsb-validation-error-msg>

        <p *ngIf="enableEmailInExport" translate>contacts_export_email_text</p>
        <input *ngIf="enableEmailInExport" class="form-control" type="email" name="email" formControlName="email" />
        <wsb-validation-error-msg *ngIf="enableEmailInExport" [fc]="exportForm.get('email')"></wsb-validation-error-msg>
        <p *ngIf="!enableEmailInExport" translate>text_receive_email_account</p>
      </form>
    </div>
  </wsb-modal>
</ng-template>
<div class="page">
  <div class="page__container">
    <h1 *ngIf="page !== 'send' && page !== 'mail'" class="page__title h2 mb-5">{{ 'contact_list' | translate }}</h1>
    <wsb-atlas-button *ngIf="page !== 'send' && page !== 'mail'" class="my-3" [label]="'contact_list_new'" (btnClick)="goToCreateContact()">{{
      'contact_list_new' | translate
    }}</wsb-atlas-button>
    <div class="my-5 contacts-grid">
      <ng-template #modalDelete let-c="close" let-d="dismiss">
        <wsb-modal
          (primary)="modalDeleteForm()"
          (dismiss)="d()"
          cancelButtonEnable="true"
          title="{{ 'common_attention' | translate }}"
          text="{{ 'contact_delete_confirm' | translate }}"
        ></wsb-modal>
      </ng-template>
      <wsb-atlas-grid
        #grid
        *ngIf="tableColumnDefs && tableGridOptions"
        class="atlas-grid-simplest contacts-grid"
        class="mt-2"
        [isMailPage]="page === 'mail' ? true : false"
        [emailList]="emailCampaignList"
        [loading]="tableLoading"
        [columnDefs]="tableColumnDefs"
        [options]="tableGridOptions"
        [@gridIsLoaded]="gridAnimationState"
        [components]="components"
        [checkboxDisable]="true"
        page="contacts"
      >
      </wsb-atlas-grid>
      <!--      [rowData]="tableData"-->
    </div>
  </div>
</div>
<ng-template #modalSuccessExport let-c="close" let-d="dismiss">
  <wsb-modal title="{{ '' | translate }}" (dismiss)="d()" (primary)="d()" text="{{ '' | translate }}">
    <div class="d-flex" body>
      <div class="align-self-center">
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-success.svg'"></span>
      </div>
      <div>
        <span [innerHtml]="'export_success1' | translate"></span>
        <span class="font-weight-bold">{{ user.profile.email }} </span>
        <span>{{ 'export_success2' | translate }}</span>
      </div>
    </div>
  </wsb-modal>
</ng-template>
